import React, { Component } from "react";
import Functions from "../../src/functions";
import Controls from "../controls";

class ModuleSearch extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
    controls: [],
  };

  constructor(props) {
    super(props);

    this.removeComponent = this.removeComponent.bind(this);
    this.addComponenet = this.addComponenet.bind(this);
    this.createCriteria = this.createCriteria.bind(this);
    this.createOperator = this.createOperator.bind(this);
    this.search = this.search.bind(this);
    this.clear = this.clear.bind(this);
    this.changeCriteria = this.changeCriteria.bind(this);

    let events = {};

    let controlProperties = {};

    if (this.props.properties) {
      Object.keys(this.props.properties).map((p, idx) => {
        let itm = this.props.properties[p];
        if (itm.search) {
          if (itm.search.name) {
            if (itm.search.type) {
              controlProperties[itm.search.name] = {
                type: itm.search.type,
                label: itm.search.label ? itm.search.label : itm.label,
                propertyName: p,
                searchProperty: itm.search,
                attributes: {
                  className: "form-control",
                },
              };
            }
          }
        }
      });
    }

    let defaultValue = [{ key: Functions.key() }];

    if (this.props.manager.state.moduleSearchData) {
      defaultValue = [];
      this.props.manager.state.moduleSearchData.forEach((itm, idx) => {
        itm["key"] = Functions.key();
        defaultValue.push(itm);
      });
    }

    this.state = {
      events: events,
      defaultValue: defaultValue,
      controlProperties: controlProperties,
      operators: {
        default: [{ label: "is", value: "=" }],
        text: [
          { label: "is", value: "=" },
          // { label: "like", value: "like" },
        ],
        date: [
          { label: "is", value: "=" },
          { label: "After", value: "gt" },
          { label: "Before", value: "lt" },
        ],

        number: [
          { label: "is", value: "=" },
          { label: "Greater than", value: "gt" },
          { label: "Lower than", value: "lt" },
        ],
      },
    };
  }

  componentDidMount() {
    if (this.didMount) {
      this.didMount();
    }
  }

  removeComponent(index) {
    let defaultValue = [...this.state.defaultValue];
    defaultValue.splice(index, 1);
    this.setState({ defaultValue: defaultValue });
  }

  addComponenet() {
    let defaultValue = this.state.defaultValue;
    defaultValue.push({ key: Functions.key() });

    this.setState({ defaultValue: defaultValue });
  }

  changeCriteria(e) {
    let propertyName = e.target.value;
    //  e.target.options[e.target.selectedIndex].getAttribute("propertyName");
    let selectedKey =
      e.target.options[e.target.selectedIndex].getAttribute("searchKey");
    let newDefaultValue = [];
    this.state.defaultValue.forEach((itm, idx) => {
      let newRecord = {};

      newRecord = { ...itm };

      if (newRecord.key == selectedKey) {
        if (propertyName) {
          newRecord["propertyName"] = propertyName;
          newRecord["value"] = "";
          newRecord["type"] = "";
        }
      }

      newDefaultValue.push(newRecord);
    });

    this.setState({ defaultValue: newDefaultValue });
  }

  createCriteria(selectedCriteria, name, key) {
    let output = [];

    Object.keys(this.state.controlProperties).forEach((itm, idx) => {
      output.push(
        <option
          value={itm}
          searchKey={key}
          propertyName={this.state.controlProperties[itm].propertyName}
        >
          {this.state.controlProperties[itm]["label"]}
        </option>
      );
    });

    return (
      <select
        className="form-control"
        defaultValue={selectedCriteria}
        name={name}
        onChange={this.changeCriteria}
      >
        <option value="">Select criteria</option>
        {output}
      </select>
    );
  }

  createOperator(selectedOperator, name, type) {
    let output = [];

    this.state.operators[type].forEach((itm, idx) => {
      output.push(<option value={itm.value}>{itm["label"]}</option>);
    });

    return (
      <select
        className="form-control"
        defaultValue={selectedOperator}
        name={name}
      >
        <option value="">Select operator</option>
        {output}
      </select>
    );
  }

  search(e) {
    e.preventDefault();

    let moduleSearchData = Functions.getFormJSON(e)["search"];
    let manager = this.props.manager;

    manager.setState({
      moduleSearchData: moduleSearchData,
      customParameters: { replace: {} },
    });

    setTimeout(function () {
      manager.refresh();
    }, 10);
  }

  clear() {
    this.setState({ defaultValue: [{ key: Functions.key() }] });

    let manager = this.props.manager;
    manager.setState({ moduleSearchData: "" });

    setTimeout(function () {
      manager.refresh();
    }, 10);
  }

  render() {
    let output = [];

    this.state.defaultValue.map((record, idx) => {
      let type = this.state.controlProperties[record["propertyName"]]
        ? this.state.controlProperties[record["propertyName"]]["type"]
        : "text";

      if (record["type"]) {
        type = record["type"];
      }

      let Control = Controls[type];

      let searchProperty = this.state.controlProperties[record["propertyName"]]
        ? this.state.controlProperties[record["propertyName"]]["searchProperty"]
        : {};

      searchProperty["alias"] = "search[" + idx + "][value]";
      searchProperty["attributes"] = { className: "form-control" };

      let operatorType = "text";

      if (type == "date" || type == "datetime") {
        operatorType = "date";
      }

      output.push(
        <div className="form-row pb-2" key={"searchrow" + record["key"]}>
          <div className="col-3">
            {this.createCriteria(
              record["criteria"],
              "search[" + idx + "][criteria]",
              record["key"]
            )}
          </div>
          <div className="col-3">
            {this.createOperator(
              record["operator"],
              "search[" + idx + "][operator]",
              operatorType
            )}
          </div>
          <div className="col-4">
            <Control
              value={record["value"]}
              property={searchProperty}
              key={Functions.key()}
            ></Control>
            <input
              type="hidden"
              name={"search[" + idx + "][type]"}
              value={type}
            ></input>
            <input
              type="hidden"
              name={"search[" + idx + "][propertyName]"}
              value={record["propertyName"]}
            ></input>
          </div>
          <div className="col-2">
            <button
              type="button"
              className="btn btn-link pointer text-danger"
              onClick={(e) => this.removeComponent(idx)}
            >
              <i className="far fa-times-circle"></i>
            </button>

            {this.state.defaultValue.length == idx + 1 ? (
              <button
                type="button"
                className="btn btn-link pointer text-success"
                onClick={(e) => this.addComponenet(idx)}
              >
                <i className="fas fa-plus-circle"></i>
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <form onSubmit={this.search}>
          <div className="row mb-2">
            <div
              className="col-11 pt-2"
              // style={{
              //   maxHeight: "140px",
              //   overflowY: "auto",
              //   overflowX: "hidden",
              // }}
            >
              {output}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12">
              <button className="btn btn-orange   mb-3 mr-2" type="submit">
                <i className="fas fa-search mr-2"></i>Search
              </button>
              <button
                className="btn btn-link text-dark border mb-3"
                type="button"
                onClick={this.clear}
              >
                <i className="fas fas fa-times mr-2"></i>Clear
              </button>
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default ModuleSearch;
